module.exports = __webpack_public_path__ + "img/wallet.6776403b.svg";